interface HeaderProps {
	id: string
	classnames?: Array<string>
	width?: string
	columnName: string
}

export const ITEMS_PER_PAGE = 20

export const TableHeader: Array<HeaderProps> = [
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.ranking",
		classnames: ["height"],
		columnName: "ranking",
	},
	{
		id: "phronesis.transactional.application.cross-selling.cross-ranking.focus",
		classnames: ["height"],
		columnName: "focus",
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.nonFocus",
		classnames: ["height"],
		columnName: "nonFocus",
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.confidenceFocus",
		columnName: "focusConfidence",
		classnames: ["spaced"],
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.confidenceNonFocus",
		columnName: "noFocusConfidence",
		classnames: ["spaced"],
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.ticketFocus",
		columnName: "trxFocus",
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.ticketNonFocus",
		classnames: ["spaced"],
		columnName: "trxNonFocus",
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.ticketCross",
		columnName: "trxCross",
		classnames: ["spaced"],
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.itemsFocus",
		classnames: ["spaced"],
		columnName: "itemsFocus",
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.itemsNonFocus",
		classnames: ["spaced"],
		columnName: "itemsNoFocus",
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.itemsCross",
		classnames: ["spaced"],
		columnName: "itemsCross",
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.avgSpendFocus",
		classnames: ["spaced"],
		columnName: "avgSpendFocus",
	},
	{
		id:
			"phronesis.transactional.application.cross-selling.cross-ranking.avgSpendNonFocus",
		classnames: ["spaced"],
		columnName: "avgSpendNoFocus",
	},
]
